import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./home.css";

function RiderFeatureIcon({ src, alt = "" }) {
  return (
    <span className="rider-feature-icon" aria-hidden>
      <img src={src} alt={alt} className="rider-feature-img" />
    </span>
  );
}

const FEATURE_ICONS = {
  coins: `${process.env.PUBLIC_URL || ""}/coins.jpeg`,
  schedule: `${process.env.PUBLIC_URL || ""}/schedule.jpeg`,
  nodel: `${process.env.PUBLIC_URL || ""}/nodel.jpeg`,
  whatsapp: `${process.env.PUBLIC_URL || ""}/whatsapp.jpeg`,
};

const FEATURES = [
  {
    key: "earn",
    icon: <RiderFeatureIcon src={FEATURE_ICONS.coins} />,
    text: "The most transparent earning source",
  },
  {
    key: "flex",
    icon: <RiderFeatureIcon src={FEATURE_ICONS.schedule} />,
    text: "Flexible Work Hours & Short Distance",
  },
  {
    key: "pressure",
    icon: <RiderFeatureIcon src={FEATURE_ICONS.nodel} />,
    text: "No Delivery Time pressure",
  },
  {
    key: "wa",
    icon: <RiderFeatureIcon src={FEATURE_ICONS.whatsapp} />,
    text: "All operations on Whatsapp",
  },
];

const DOCS = [
  "Aadhaar Card",
  "Driving License",
  "Your Selfie",
  "Vehicle Number Plate",
];

export default function Home() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleBecomeRider = () => {
    const code = searchParams.get("code");
    const uploadPath = code ? `/upload?code=${encodeURIComponent(code)}` : "/upload";
    navigate(uploadPath);
  };

  return (
    <div className="rider-landing">
      <main className="rider-landing__main">
        <button
          type="button"
          className="rider-landing__brand"
          onClick={() => navigate("/")}
          aria-label="OZU home"
        >
          <img
            src="/ozu-logo.svg"
            alt="OZU"
            width={67}
            height={20}
            className="rider-landing__logo-img"
          />
        </button>

        <h1 className="rider-landing__headline">
          Become a Rider with Ozu
        </h1>

        <div className="rider-landing__card">
          {FEATURES.map((row, i) => (
            <div
              className={`rider-landing__feature${i === FEATURES.length - 1 ? " rider-landing__feature--last" : ""}`}
              key={row.key}
            >
              {row.icon}
              <p className="rider-landing__feature-text">{row.text}</p>
            </div>
          ))}
        </div>

        <section
          className="rider-landing__docs-section"
          aria-labelledby="rider-docs-heading"
        >
          <h2 className="rider-landing__docs-heading" id="rider-docs-heading">
            Keep your document ready
          </h2>
          <ul className="rider-landing__docs-grid">
            {DOCS.map((label) => (
              <li className="rider-landing__doc-item" key={label}>
                <span className="rider-landing__check" aria-hidden>
                  ✓
                </span>
                <span>{label}</span>
              </li>
            ))}
          </ul>
        </section>

        <button type="button" className="rider-landing__cta" onClick={handleBecomeRider}>
          Become a Rider
        </button>
      </main>
    </div>
  );
}
